import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { LogOut, PlusCircle, X } from 'react-feather';
import { getUserList, sortUsers } from '../../helpers/ArrayUtils';

import * as constants from '../../constants/AppConstants';
import { getChatTypeName, isDirectMessage, isPrivateChannel } from '../../helpers/ChatUtils';

import User from '../User';
import ModalContent from '../ModalContent';

export default class ChatDetailsPanel extends Component {
  static propTypes = {
    chat: PropTypes.shape({
      id: PropTypes.number,
      users: PropTypes.array,
      name: PropTypes.string,
      type: PropTypes.string,
      lastMessageRead: PropTypes.number,
    }),
  };

  /** Leave Chat modals */
  openModal = () => this.props.updateModal(this.leaveChannelModal());
  closeModal = () => this.props.hideModal();

  /** Dispatches action to leave this channel and routes to root */
  leaveChannelHandler = () => {
    this.closeModal();
    this.props.leaveChannel(this.props.chatId);
    this.props.history.push('/');
  };

  /** Modal that shows when a user clicks Leave Chat */
  leaveChannelModal = () => {
    const { chat } = this.props;
    const chatTitle = chat && chat.name ? chat.name : 'This';
    return (
      <ModalContent
        modalTitle="Are you sure you want to leave this channel?"
        modalConfirmTitle="Leave"
        modalConfirmAction={this.leaveChannelHandler}
        modalCloseAction={this.closeModal}
        qaId={`chatDetailsPanelLeaveChannel-${this.props.chatId}`}
      >
        {chat &&
          <p><em>{chatTitle}</em> is a <strong>{getChatTypeName(chat)}</strong>. {this.getChatLeaveMessage(chat)}</p>
        }
      </ModalContent>
    );
  };

  getChatLeaveMessage = chat => isPrivateChannel(chat) ? constants.LEAVE_CHAT_UNABLE_TO_REJOIN_MSG : constants.LEAVE_CHAT_ABLE_TO_REJOIN_MSG;

  render() {
    const { chat, chatId, users, identityId } = this.props;
    const chatType = getChatTypeName(chat);

    return (
      <div className="chat-details-panel flex flex-column" data-qa="chatDetails">
        <div className="panel-title" data-qa="chatDetailsHeading">
          <h1>Chat Info</h1>
          <Link
            to={`/chat/${chatId}`}
            className="closeButton"
            data-qa="chatDetailsClose"
          >
            <X size={24}/>
          </Link>
        </div>
        <div className="panel-content flex flex-column chat-details-content">
          {chat && chatId && (
            <Fragment>
              {chat.name && <h2>{chat.name}</h2>}
              <h5>{chatType}</h5>
              <h2>Current Users</h2>
              {users &&
              <div className="chat-users" data-qa="chatDetailsUsers">
                {sortUsers(getUserList(chat.users, users)).map((user, index) => {
                  return (
                    <User
                      data-qa={`userDetailsView-${index}`}
                      key={index}
                      {...user}
                      size={constants.USER_SIZE_SMALL}
                      isCurrentUser={user.id === identityId}
                    />
                  );
                })}
              </div>
              }
              {!isDirectMessage(chat) &&
              <Link
                to={`/chat/${chatId}/invite`}
                data-qa={`chatDetailsPanelInviteUsers-${chatId}`}
                className="invite-users-link"
              >
                <PlusCircle size={16}/>
                Invite People
              </Link>
              }
            </Fragment>
          )}
        </div>
        {!isDirectMessage(chat) &&
          <button
            className="leave-channel-group"
            onClick={this.openModal}>
            <LogOut size={12}/>Leave Chat
          </button>
        }
      </div>
    );
  }
};
